import React, { Component } from 'react';

import FieldModal from '../../../../components/modals/fieldModal';
import Dropzone from 'react-dropzone';
import API from '../../../../utils/API';

let dropzoneRef2;
class FilesUploadModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			files: [],
			folder: props.folder,
			uploading: false
		};
	}
	onDrop = (files) => {
		const existingFiles = this.state.files;
		files.forEach((f) => existingFiles.push(f));
		this.setState({
			files: existingFiles
		});
	};

	uploadFiles = () => {
		const { orgId, eventId } = this.props;
		const { files, folder } = this.state;
		if (files.length > 0) {
			this.setState({
				uploading: true
			});
			const data = new FormData();
			if (this.props.parentFolder) {
				data.append('parentFolder', this.props.parentFolder);
			}
			data.append('targetDirectory', folder);
			files.forEach((f) => data.append(`files`, f));

			API()
				.post(`Organizations/${orgId}/events/${eventId}/assets`, data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				})
				.then((res) => {
					if (res.data) {
						this.props.addFiles(res.data.assets);
						this.props.toggle();
					}
				})
				.catch((e) => {
					console.log(e);
					this.setState({ error: true, uploading: false });
				});
		}
	};

	removeFile = (file) => {
		const filteredFiles = this.state.files.filter((f) => f.name !== file.name);
		this.setState({ files: filteredFiles });
	};

	render() {
		const { isOpen, toggle } = this.props;
		const { files, uploading } = this.state;
		return (
			<div>
				<FieldModal
					size="medium"
					isOpen={isOpen}
					modalTitle={"Upload files"}
					bodyHeaderText={''}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div>
								<Dropzone
									className="clickable dropzone"
									inputProps={{ style: { margin: 'auto' } }}
									ref={(node) => {
										dropzoneRef2 = node;
									}}
									onDrop={this.onDrop.bind(this)}
								>
									<div className="dropzoneDescriptionContainer">
										<p>
											<span style={{ color: '#2B83F1' }}>Browse</span>, or drop a file here or click to upload.
										</p>
									</div>
								</Dropzone>
								{files.length > 0 && (
									<div className="filePreviewList">
										{files.map((file) => (
											<div className="filePreview">
												<div className="removeFileBtn" onClick={() => this.removeFile(file)}>
													<i className="las la-times" />
												</div>
												<img
													src={file.type.includes('image') ? file.preview : ''}
													className="filePreviewImage"
												/>
											</div>
										))}
									</div>
								)}
							</div>)
					}}
					toggle={toggle}
					actionButtonLabel={!uploading ? 'Upload' : 'Uploading...'}
					actionButton={() => this.uploadFiles()}
					actionButtonDisabled={uploading}


				></FieldModal>

			</div>

		);
	}
}

export default FilesUploadModal;
